export default __webpack_public_path__ + "static/media/iklan.46cf1876.png";